import webIcon from "../assets/webIcon2.png";
import editIcon from "../assets/editIcon.png";
import gfxIcon from "../assets/gfxIcon.png";
import animateIcon from "../assets/animateIcon.png";
import socialIcon from "../assets/socialIcon.png";
export const navItems = [
  {
    label: "Services",
    href: "#Services",
  },
  {
    label: "Portfolio",
    href: "#Portfolio",
  },
  {
    label: "About",
    href: "#About",
  },
  {
    label: "Contact us",
    href: "#Contact",
  },
];

export const offerServices = [
  {
    // delay: 0.5,
    // name: "Video Editing",
    // image: editIcon,
    // heading:
    //   '"Editing is where the magic happens, turning moments into timeless stories."',
    // ref: "ref1",
    // description:
    //   "Editing is the transformative magic that breathes life into raw moments, weaving them into timeless stories. Through thoughtful cuts, transitions, and enhancements, they craft narratives that resonate deeply with audiences, leaving a lasting impact that transcends the screen. In the hands of a talented editor, every frame becomes an opportunity to create something truly memorable and meaningful",
  },
  {
    // delay: 0.2,
    // ref: "ref2",
    // name: "Graphic Designing",
    // image: gfxIcon,
    // heading: '"Design is intelligence made visible."',
    // description:
    //   "Graphic design is the art of making intelligence visible through visual communication.  In the hands of a skilled designer, every pixel and line serves a strategic purpose, enhancing brand identity and storytelling. Graphic design is not just about aesthetics; it's about crafting meaningful experiences that resonate with audiences and leave a lasting impression.",
  },
  // {
  //   delay: 0.1,
  //   ref: "ref3",

  //   name: "Animation",
  //   image: animateIcon,
  //   heading: '"Where dreams dance in the flicker of frames."',
  //   description:
  //     "Where dreams dance in the flicker of frames. Each frame, meticulously crafted, tells a story that transcends reality, capturing the imagination and transporting viewers to worlds beyond their own. Through the magic of animation, dreams come alive, dancing vividly before our eyes, leaving an indelible mark on our hearts and minds.",
  // },
  {
    // delay: 0.3,
    // ref: "ref4",
    // name: "Web Development",
    // image: webIcon,
    // heading:
    //   '"Our expertise turns ideas into interactive, user-friendly websites that captivate and convert."',
    // description:
    //   "Elevating your online presence through innovative design and seamless functionality. Experience the perfect blend of creativity and technology, and watch your digital dreams come to life.From design to deployment, we ensure a seamless, responsive experience that elevates your brand and sets you apart in the digital landscape.",
  },
  {
    // delay: 0.4,
    // ref: "ref5",
    // name: "Social Media Handling",
    // image: socialIcon,
    // heading: '"Curating your digital narrative with creativity and strategy."',
    // description:
    //   "Elevate your brand's presence with compelling visuals and strategic engagement.  From content creation to audience interaction, we handle every aspect of your Instagram presence, ensuring consistent growth and engagement. Let us transform your Instagram into a powerful tool for brand recognition and customer loyalty",
  },
];

export const carouselContent = [
  {
    review:
      "Lovely working with Raj. Service was as promised and communication was very effective and open.",
    name: "Anonymous User",
  },
  {
    review: "They delivered more than we expected, GREAT WORK! Keep it up!",
    name: "Anonymous User",
  },
  {
    review:
      "Their editors, creators and coders have excellent work experience.",
    name: "Anonymous User",
  },
  {
    review: "We got our entire products completed in time",
    name: "Anonymous User",
  },
  {
    review:
      "They have very good after production services! We did not face any issues.",
    name: "Anonymous User",
  },
];
